import { SkeletonText, StackLayout, Box } from '@leagueplatform/genesis-core';
import { FullScreenContainer } from 'components/full-screen-container/full-screen-container.component';

export const ImpersonationSkeleton = () => (
  <FullScreenContainer>
    <StackLayout
      orientation="vertical"
      horizontalAlignment="center"
      verticalAlignment="center"
      css={{
        height: '100%',
        width: '100%',
        textAlign: 'center',
      }}
    >
      {/* Loading Message */}
      <Box css={{ marginBottom: '$three' }}>
        <SkeletonText header width={300} css={{ marginBottom: '$one' }} />
        <SkeletonText lines={2} />
      </Box>

      {/* Loading Indicator */}
      <Box
        css={{
          width: '60px',
          height: '60px',
          backgroundColor: '$surfaceBackgroundSecondary',
          borderRadius: '$full',
          marginBottom: '$two',
        }}
      />

      {/* Status Text */}
      <SkeletonText width={200} />
    </StackLayout>
  </FullScreenContainer>
);
